module.exports = __webpack_public_path__ + "static/media/coraxing.a0332ab7.jpeg";